import type { IFlattenedCategory } from "app/common/services/categoryService.types";
import { useApiQuery } from "app/modules/api-client";
import { INDUSTRY_ENDPOINT_MIN_DATE } from "app/pages/digital-marketing/ad-intelligence/common/data-availability/industryDataAvailability";

import { FIRST_PAGE, PAGE_SIZE_SMALL } from "../../../utils/utils";
import { useIndustryAvailabilityParams } from "../useIndustryAvailabilityParams";

export interface IIndustryPublisherPreviewRow {
    publisher: string;
    rank: number;
    spend: number;
    siteKey: string;
    spendShare: number;
    impressionsShare: number;
    visitsShare: number;
}

export const useIndustryTopPublishersPreview = (category: IFlattenedCategory) => {
    const { params, availability } = useIndustryAvailabilityParams(
        category,
        INDUSTRY_ENDPOINT_MIN_DATE.adintelligenceIndustryTopPublishersPreviewList,
    );

    const { data, isLoading, isFetching, isError } = useApiQuery(
        {
            tag: "AdIntelligenceMarketingAssets",
            methodName: "adintelligenceIndustryTopPublishersPreviewList",
            options: {
                enabled: !availability.isFullyUnavailable,
                select: (response) => ({
                    rows: (response?.data ?? []).map((item) => ({
                        publisher: item.publisher ?? "",
                        rank: item.rank ?? 0,
                        spend: item.spend ?? 0,
                        siteKey: item.siteKey ?? "",
                        spendShare: item.spendShare ?? 0,
                        impressionsShare: item.impressionsShare ?? 0,
                        visitsShare: item.visitsShare ?? 0,
                    })),
                    totalCount: response?.totalCount ?? 0,
                }),
            },
        },
        {
            ...params,
            page: FIRST_PAGE,
            pageSize: PAGE_SIZE_SMALL,
        },
    );

    return {
        rows: data?.rows ?? [],
        totalCount: data?.totalCount ?? 0,
        isLoading: isLoading || isFetching,
        isError,
        availability,
    };
};
